import { Close, Folder } from '@mui/icons-material'
import { Box, Button, Checkbox, FormControl, FormControlLabel, FormGroup, Grid, IconButton, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'

const Antecedentes = ({ datos, setDatos, errores }) => {
    const [galeriaAntecedentes, setGaleriaAntecedentes] = useState(datos.galeria_antecedentes.length > 0 ? datos.galeria_antecedentes : []);
    const removeImg = (index) => {
        setGaleriaAntecedentes(prevGaleria => {
            let newGal = [...prevGaleria];
            newGal = newGal.filter((img, i) => i !== index);
            return newGal;
        });
    }
    const handleInput = (e) => {
        let imagen = e.target.files[0] ?? null;
        if (imagen) {
            const reader = new FileReader();
            reader.onload = (readerEvent) => {
                imagen.dataurl = readerEvent.target.result
                setGaleriaAntecedentes(prevGaleria => [...prevGaleria, imagen]);
            }
            reader.readAsDataURL(imagen);
        }
    }

    const [checkedItems, setCheckedItems] = useState(datos.forma_integracion);

    const handleCheckboxChange = (value) => {
        const updatedItems = checkedItems.includes(value)
            ? checkedItems.filter((item) => item !== value)
            : [...checkedItems, value];

        setCheckedItems(updatedItems);
        //onChange(updatedItems);
    };

    useEffect(() => {
        //console.log(checkedItems);
        setDatos({ target: { name: "forma_integracion", value: checkedItems } });
    }, [checkedItems]);
    useEffect(() => {
        setDatos({ target: { name: "galeria_antecedentes", value: galeriaAntecedentes } });
    }, [galeriaAntecedentes]);
    return (
        <Box sx={{ mb: { xs: 10, lg: 0 } }}>
            <Typography variant="h6" sx={{ mb: 2 }}>Antecedentes de la empresa</Typography>
            <TextField inputProps={{ maxLength: 100 }} required value={datos.fecha_lugar_origen} onChange={setDatos} sx={{ mb: 2 }} fullWidth name="fecha_lugar_origen" label="Fecha y lugar en que se estableció la empresa" />
            <TextField required value={datos.origen} onChange={setDatos} sx={{ mb: 2 }} fullWidth name="origen" label="Origen de la organizacion hasta el establecimiento de la empresa" multiline minRows={5} />
            <TextField inputProps={{ maxLength: 4 }} name="year_inicio" value={datos.year_inicio} onChange={setDatos} required type="number" fullWidth label="Año de inicio de la organización" />

            <Grid container spacing={2}>
                <Grid item xs={12} lg={4}>
                    <Typography variant="h6" sx={{ my: 2 }}>¿Cómo se integró la organización?</Typography>
                    <FormGroup>
                        <FormControlLabel
                            control={<Checkbox checked={checkedItems.includes(1)} onChange={() => handleCheckboxChange(1)} />}
                            label={<MenuItem>Vecinos</MenuItem>}
                        />
                        <FormControlLabel
                            control={<Checkbox checked={checkedItems.includes(2)} onChange={() => handleCheckboxChange(2)} />}
                            label={<MenuItem>Asoc. de productores</MenuItem>}
                        />
                        <FormControlLabel
                            control={<Checkbox checked={checkedItems.includes(3)} onChange={() => handleCheckboxChange(3)} />}
                            label={<MenuItem>Iglesia</MenuItem>}
                        />
                        <FormControlLabel
                            control={<Checkbox checked={checkedItems.includes(4)} onChange={() => handleCheckboxChange(4)} />}
                            label={<MenuItem>Promoción de técnicos</MenuItem>}
                        />
                        <FormControlLabel
                            control={<Checkbox checked={checkedItems.includes(5)} onChange={() => handleCheckboxChange(5)} />}
                            label={<MenuItem>Promoción de ONGs</MenuItem>}
                        />
                        <FormControlLabel
                            control={<Checkbox checked={checkedItems.includes(6)} onChange={() => handleCheckboxChange(6)} />}
                            label={<MenuItem>Gobierno local</MenuItem>}
                        />
                        <FormControlLabel
                            control={<Checkbox checked={checkedItems.includes(7)} onChange={() => handleCheckboxChange(7)} />}
                            label={<MenuItem>Otro</MenuItem>}
                        />
                    </FormGroup>
                </Grid>
                <Grid item xs={12} lg={8}>
                    <Typography variant="h6" sx={{ my: 2 }}>Socios de la organización en sus origenes</Typography>
                    <TextField sx={{ my: 1 }} name="cant_socios_hombres_iniciales" value={datos.cant_socios_hombres_iniciales} onChange={setDatos} required type="number" fullWidth label="Cant. de hombres" />
                    <TextField sx={{ my: 1 }} name="cant_socios_mujeres_iniciales" value={datos.cant_socios_mujeres_iniciales} onChange={setDatos} required type="number" fullWidth label="Cant. de mujeres" />
                    <TextField sx={{ my: 1 }} name="cant_familias_iniciales" value={datos.cant_familias_iniciales} onChange={setDatos} required type="number" fullWidth label="Total de familias participantes" />
                </Grid>

                <Grid item xs={12} lg={12}>
                    <Typography variant="h6">Fotogalería de las primeras sesiones de la empresa</Typography>
                    <Typography>(Máximo 3 fotografías)</Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                        {galeriaAntecedentes.map((image, i) => (
                            <Box key={image.dataurl} sx={{ position: 'relative', mr: 2, mb: 2, border: 1, borderColor: '#e0dcda', p: 1, display: 'flex', alignItems: 'center' }}>
                                <IconButton sx={{ color: '#ff4444', position: 'absolute', top: 0, right: 0, m: 1 }} onClick={() => removeImg(i)}>
                                    <Close />
                                </IconButton>
                                <img src={image.dataurl} alt={image.name} width="150px" />
                            </Box>
                        ))}
                    </Box>
                    <Box sx={{ my: 2, display: 'flex', }}>
                        <Button disabled={galeriaAntecedentes.length > 2} component="label" variant="contained" startIcon={<Folder />}>
                            Agregar <input name={`galeria_antecedentes`} onInputCapture={(e) => handleInput(e)} type="file" accept='image/*' hidden />
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </Box >
    )
}

export default Antecedentes